const UPLOAD_SUCCESS_MESSAGES = {
  product: 'Your product import has started and is processing in the background.',
  purchasableStatus:
    'Your purchasable status import has started and is processing in the background.',
  inventory: 'Your inventory import has started and is processing in the background.',
  location: 'Your location import has started and is processing in the background.',
  promotion: 'Your promotion import has started and is processing in the background.',
  posStorePromotion:
    'Your POS store promotion import has started and is processing in the background.',
  upcomingPromotion:
    'Your upcoming promotion import has started and is processing in the background.',
  category: 'Your category import has started and is processing in the background.',
  division: 'Your division import has started and is processing in the background.',
  bulkBarcode: 'Your bulk barcode upload has completed.',
  deliveryTime: 'Your delivery time import has started and is processing in the background.',
}

/**
 * @param {'product' | 'inventory' | 'location' | 'promotion' | 'posStorePromotion' | 'upcomingPromotion' | 'category' | 'bulkBarcode' | 'deliveryTime'} uploadType
 */
export function getUploadSuccessMessage(uploadType) {
  return UPLOAD_SUCCESS_MESSAGES[uploadType] ?? UPLOAD_SUCCESS_MESSAGES.product
}

export { UPLOAD_SUCCESS_MESSAGES }
